function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "46",
  height: "30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".46",
  clipPath: "url(#clip0_1584_84165)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 29.808c12.703 0 23-2.236 23-4.994 0-2.758-10.297-4.994-23-4.994S0 22.056 0 24.814c0 2.758 10.297 4.994 23 4.994z",
  fill: "var(--empty-icon-accent-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.531 10.375L32.24 2.169c-.35-.56-.861-.898-1.4-.898H15.161c-.539 0-1.05.339-1.4.897L6.47 10.375v6.592H39.53v-6.592z",
  fill: "var(--empty-icon-primary-color)",
  stroke: "var(--empty-icon-accent-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.91 12.636c0-1.145.714-2.09 1.6-2.091h8.021v12.94c0 1.514-.948 2.755-2.12 2.755H8.589c-1.171 0-2.12-1.242-2.12-2.756v-12.94h8.021c.886 0 1.6.945 1.6 2.09v.015c0 1.146.723 2.07 1.608 2.07h10.604c.885 0 1.607-.933 1.607-2.078v-.005z",
  fill: "var(--empty-icon-primary-color)",
  stroke: "var(--empty-icon-accent-color)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1584_84165"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--empty-icon-primary-color)",
  transform: "translate(0 .559)",
  d: "M0 0h46v29.25H0z"
})))));